import dayjs from "@/utils/dayjs";
import { MOMENT_FORMAT } from "@/constants";
import {
  DailyWeatherForecastData,
  WeatherForecastData,
} from "@/types/forecast";

export type CityClock = {
  hour: number;
  todayKey: string;
};

const pad2 = (n: number) => String(n).padStart(2, "0");

export const getCityClock = (offsetSeconds?: number): CityClock => {
  if (typeof offsetSeconds !== "number" || !Number.isFinite(offsetSeconds)) {
    const now = dayjs();
    return { hour: now.hour(), todayKey: now.format(MOMENT_FORMAT) };
  }
  const shifted = new Date(Date.now() + offsetSeconds * 1000);
  return {
    hour: shifted.getUTCHours(),
    todayKey: `${shifted.getUTCFullYear()}-${pad2(shifted.getUTCMonth() + 1)}-${pad2(shifted.getUTCDate())}`,
  };
};

export const getCityUtcOffsetSeconds = (
  weather?: WeatherForecastData,
): number | undefined => {
  for (const day of Object.values(weather ?? {})) {
    if (typeof day?.utcOffsetSeconds === "number") return day.utcOffsetSeconds;
  }
  return undefined;
};

export const getCityClockFromDay = (
  day?: DailyWeatherForecastData,
): CityClock => getCityClock(day?.utcOffsetSeconds);

export const getCityClockFromWeather = (
  weather?: WeatherForecastData,
): CityClock => getCityClock(getCityUtcOffsetSeconds(weather));
